import { useMemo } from 'react';
import { useCurrentUser } from '../services/userHooks';
import type { Folder } from '../types/api';

export function useFolderBySlug(slug: string): Folder | undefined {
  const { currentUser } = useCurrentUser();

  return useMemo(() => {
    if (!currentUser?.folders || !slug) return undefined;
    return currentUser.folders.find((folder) => folder.slug === slug);
  }, [currentUser?.folders, slug]);
}
